import type { Edge, Node, Viewport } from "@xyflow/react";
import { decodeBoardSnapshot } from "./board-document";

export interface PreviewSession {
  graph: { nodes: Node[]; edges: Edge[] };
  viewport: Viewport;
  workingViewport: Viewport;
}

export function parsePreviewSnapshot(snapshot: unknown, fallbackViewport: Viewport) {
  // A history entry must contain an actual document; only a new diagram may be NULL.
  if (snapshot == null) throw new Error("Missing version snapshot");
  const parsed = decodeBoardSnapshot(snapshot);
  return { graph: { nodes: parsed.nodes, edges: parsed.edges },
    viewport: parsed.viewport ?? { ...fallbackViewport } };
}

export function beginHistoryPreview(snapshot: unknown, session: PreviewSession | null, viewport: Viewport): PreviewSession {
  const preview = parsePreviewSnapshot(snapshot, viewport);
  return { ...preview, workingViewport: { ...(session?.workingViewport ?? viewport) } };
}

export function exitHistoryPreview(session: PreviewSession): { session: null; viewport: Viewport } {
  return { session: null, viewport: { ...session.workingViewport } };
}
